import angular from 'angular'
import MediaLibrary from 'emun.medialibrary/medialibrary'

const dependencies = ['emun.auth','webutils', 'webforms', 'webmodals', 'ui.router'];

export default angular.module('emun.medialibrary', dependencies)
	.component('mediaLibrary', MediaLibrary)
	.name;